import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import ActivitiesController from '../../../common/activitiesController/ActivitiesController'
import Toggle from 'react-toggle'

class CruiseTripSlotList extends React.Component {
  state = {
    data: [],
    is_bulk_deleting: false,
  }
  componentDidMount() {
    if (this.props?.match?.params?.tripId) {
      this.getData(this.props.match.params.tripId)
    }
  }

  getData = async (id) => {
    await axios
      .get(Constant.getAPI() + `/trips/get-all-trip-slots/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            data: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteItem = (id) => {
    axios
      .delete(Constant.getAPI() + `/trips/delete-trip-slot/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        Swal.fire({
          title: 'Slot Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.getData(this.props?.match?.params?.tripId)
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChange = async (id) => {
    await axios
      .put(Constant.getAPI() + `/trips/update-trip-slot-status/${id}`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            toast: true,
            icon: 'success',
            position: 'top-end',
            title: `TimeSlot Updated Successfully!`,
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2500,
          })
          this.getData(this.props?.match?.params?.tripId)
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChangeForAll = async (event, selectedRows, displayData) => {
    var ids = []
    for (let i = 0; i < selectedRows.data.length; i++) {
      if (
        displayData.length &&
        displayData[selectedRows.data[i].dataIndex] &&
        displayData[selectedRows.data[i].dataIndex].data &&
        displayData[selectedRows.data[i].dataIndex].data[0]
      ) {
        ids.push(displayData[selectedRows.data[i].dataIndex].data[0])
      }
    }

    ids.forEach((id) => {
      let temp_data = this.state.data
      let selectedData

      temp_data.forEach((itm) => {
        if (itm.date == id) {
          selectedData = itm
          itm['is_disabled'] = event.target.value
        }
      })

      this.setState({ data: temp_data })

      selectedData['is_disabled'] = event.target.value
      axios
        .put(Constant.getAPI() + `/trips/update-trip-slot-status/${selectedData.id}`, {}, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            Swal.fire({
              toast: true,
              icon: 'success',
              position: 'top-end',
              title: `TimeSlot Updated Successfully!`,
              showConfirmButton: false,
              timerProgressBar: true,
              timer: 2500,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    })
  }

  deletebulkSlots = async (selectedRows, displayData, setSelectedRows) => {
    this.setState({
      is_bulk_deleting: true,
    })

    const tempArr = []
    for (let i = 0; i < selectedRows.data.length; i++) {
      if (
        displayData.length &&
        displayData[selectedRows.data[i].dataIndex] &&
        displayData[selectedRows.data[i].dataIndex].data &&
        displayData[selectedRows.data[i].dataIndex].data[0]
      ) {
        tempArr.push(new Date(displayData[selectedRows?.data[i]?.dataIndex]?.data[0]))
      }
    }

    if (tempArr?.length > 0) {
      const requestData = {
        trip_id: this.props.match.params.tripId,
        delete_slots_arr: tempArr,
      }

      await axios.post(Constant.getAPI() + '/trips/delete-bulk-slots', requestData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }

    Swal.fire({
      title: 'Slot Deleted Successfully!',
      icon: 'success',
      text: '',
      type: 'success',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
    })

    this.setState({
      is_bulk_deleting: false,
    })
    this.getData(this.props?.match?.params?.tripId)
    setSelectedRows([])
  }

  render() {
    const columns = [
      {
        name: 'from_date',
        label: 'From Date',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'to_date',
        label: 'To Date',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (isActive, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div>
                <Toggle
                  id={id}
                  checked={isActive}
                  value={isActive + ''}
                  onChange={this.handleStatusChange.bind(this, id)}
                />
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <span
                  onClick={this.deleteItem.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
        return (
          <>
            <select
              style={{ width: 150, marginRight: 10 }}
              name="is_disabled"
              className={`form-control`}
              defaultValue=""
              onChange={(event) => this.handleStatusChangeForAll(event, selectedRows, displayData, setSelectedRows)}
            >
              <option
                selected
                value=""
              >
                Select Status
              </option>
              <option value="true">Close</option>
              <option value="false">Open</option>
            </select>
          </>
        )
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Cruise Trip Slots List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/cruise-trip-slots/${this.props?.match?.params?.tripId}/add`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Slot
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/cruise-trip-details/${this.props?.match?.params?.tripId}`}>
                          <i className="feather">Cruise Trip Details</i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Slots List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Cruise Trip Slots List'}
                          className="table-responsive"
                          data={this.state.data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CruiseTripSlotList
